import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CustomInput, CustomSelect, NoResult, Text } from '../../../ui/atoms';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { APPROVAL_REQUESTS_GET } from '../../redux/actions/eventApproval';
import {
  APPROVAL_STATUS_OPTIONS,
  VISIBILITY_OPTIONS,
  getFilterLabel,
} from '../../../utils/labels';
import SortBy from '../../../ui/atoms/SortBy';
import { CardsWrapper, FiltersWrapper, Legend, RequestCard } from './style';
import Pagination from '../../../ui/atoms/Pagination';
import { timestampToDate } from '../../../utils/common';
import MultiActions from '../../../ui/atoms/MultiActions';
import routes from '../../../routes';
import { TUTOR_COURSE_DELETE } from '../../redux/actions/tutorCourseList';

const defaultFilters = {
  typology: 'event',
  approval_status: ['APPROVED', 'REJECTED'],
};

const OldRequests = ({
  mediaIsPhone,
  list,
  pager,
  getApprovalList,
  deleteCourse,
}) => {
  const navigate = useNavigate();
  //  filters
  const [selectedFilters, setSelectedFilters] = useState(defaultFilters);
  const [searchValue, setSearchValue] = useState();

  const handleGetApprovalList = (page) => {
    if (!selectedFilters?.approval_status) {
      selectedFilters.approval_status = defaultFilters.approval_status;
    }
    getApprovalList({ ...selectedFilters, page });
  };

  useEffect(() => {
    handleGetApprovalList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handleGetApprovalList(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });
  return (
    <>
      <FiltersWrapper className="d-flex mb-4">
        <CustomInput
          size={mediaIsPhone ? 'full' : 'm'}
          placeholder="Cosa vuoi cercare?..."
          isSearch
          value=""
          icon="search-sm"
          isClearable
          onChange={(v) => setSearchValue(v)}
          onClickIcon={onClickSearch}
          onKeyPress={(event) => {
            if (event.key === 'Enter') onClickSearch();
          }}
        />
        <CustomSelect
          placeholder="Stato"
          size={mediaIsPhone ? 'full' : 's'}
          options={VISIBILITY_OPTIONS}
          onChange={(v) => handleOnChange({ key: 'published', value: v })}
          isClearable
        />
        <CustomSelect
          placeholder="Stato approvazione"
          size={mediaIsPhone ? 'full' : 's'}
          options={APPROVAL_STATUS_OPTIONS.filter(
            (o) => o.value !== 'TO_BE_APPROVED'
          )}
          onChange={(v) => handleOnChange({ key: 'approval_status', value: v })}
          isClearable
        />
      </FiltersWrapper>
      <div className="d-flex sb mb-4">
        <Text type="b3">{pager?.total_items} risultati</Text>
        <SortBy
          onChange={(v) => {
            setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
          }}
        />
      </div>
      {list?.length > 0 ? (
        <CardsWrapper>
          {!mediaIsPhone && (
            <Legend className="old">
              <Text type="h3.5">Codice</Text>
              <Text type="h3.5">TITOLO PERCORSO FORMATIVO</Text>
              <Text type="h3.5">Richiesta da</Text>
              <Text type="h3.5">Stato</Text>
              <Text type="h3.5">Stato approvazione</Text>
              <Text type="h3.5">DATA DI creazione</Text>
            </Legend>
          )}
          {list.map((item) => {
            if (mediaIsPhone) {
              return (
                <RequestCard key={`card-${item?.id}`} className="old">
                  <Text type="h3.5">Codice</Text>
                  <Text type="b4" className="code">
                    {item?.code}
                  </Text>
                  <Text type="h3.5">TITOLO PERCORSO FORMATIVO</Text>
                  <Text type="h3" className="line-clamp">
                    {item?.title}
                  </Text>
                  <Text type="h3.5">Richiesta da</Text>
                  <Text type="b4">
                    {item?.owner_first_name} {item?.owner_last_name}
                  </Text>
                  <Text type="h3.5">Stato</Text>
                  <Text type="b4">
                    {item?.published ? 'Visibile' : 'Non vsibile'}
                  </Text>
                  <Text type="h3.5">Stato approvazione</Text>
                  <Text type="b4">{getFilterLabel(item?.approval_status)}</Text>
                  <Text type="h3.5">DATA DI creazione</Text>
                  <Text type="b4">{timestampToDate(item?.created)}</Text>
                  <div />
                  <MultiActions
                    actions={[
                      {
                        label: 'Modifica',
                        icon: 'edit-05',
                        onClick: () =>
                          navigate(`${routes.editEvent.path}/${item.id}`),
                      },
                      {
                        label: 'Elimina',
                        icon: 'trash-01',
                        onClick: () => deleteCourse(item.id),
                      },
                    ]}
                  />
                </RequestCard>
              );
            }
            return (
              <RequestCard key={`card-${item?.id}`} className="old">
                <Text type="b4" className="code">
                  {item?.code}
                </Text>
                <Text type="h3" className="line-clamp">
                  {item?.title}
                </Text>
                <Text type="b4">
                  {item?.owner_first_name} {item?.owner_last_name}
                </Text>
                <Text type="b4">
                  {item?.published ? 'Visibile' : 'Non vsibile'}
                </Text>
                <Text type="b4">{getFilterLabel(item?.approval_status)}</Text>
                <Text type="b4">{timestampToDate(item?.created)}</Text>
                <MultiActions
                  actions={[
                    {
                      label: 'Modifica',
                      icon: 'edit-05',
                      onClick: () =>
                        navigate(`${routes.editEvent.path}/${item.id}`),
                    },
                    {
                      label: 'Elimina',
                      icon: 'trash-01',
                      onClick: () =>
                        deleteCourse({
                          id: item.id,
                          callback: handleGetApprovalList,
                        }),
                    },
                  ]}
                />
              </RequestCard>
            );
          })}
          {pager?.number_of_pages > 0 && (
            <Pagination
              pt={38}
              pager={pager}
              callBack={loadMore}
              setItemsPerPage={setItemsPerPage}
            />
          )}
        </CardsWrapper>
      ) : (
        <NoResult />
      )}
    </>
  );
};

OldRequests.propTypes = {
  mediaIsPhone: PropTypes.bool,
  list: PropTypes.array,
  pager: PropTypes.object,
  getApprovalList: PropTypes.func,
  deleteCourse: PropTypes.func,
};

export default connect(
  (state) => {
    const {
      oldRequests: { list, pager },
    } = state.eventApproval;
    return { list, pager };
  },
  (dispatch) => ({
    getApprovalList: (filters) =>
      dispatch({ type: APPROVAL_REQUESTS_GET._REQUEST, filters }),
    deleteCourse: ({ id, callback }) =>
      dispatch({ type: TUTOR_COURSE_DELETE._REQUEST, id, callback }),
  })
)(withMediaQueries(OldRequests));
